import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import "./EventAbsentees.css";

const EventAbsentees = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [eventInfo, setEventInfo] = useState(null);
  const [participations, setParticipations] = useState([]);
  const [absentReasons, setAbsentReasons] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //  イベント情報の取得
        const eventRes = await api.get(`/events/${eventId}/`);
        setEventInfo(eventRes.data);

        // 全ての社員情報の取得
        const empRes = await api.get("/employees/");
        const employees = empRes.data;

        // 参加状況の取得
        const partRes = await api.get(`/events/${eventId}/results/`);
        const parts = partRes.data;
        setParticipations(parts);


        // 不参加理由の収集
        const reasons = parts
          .filter((p) => !p.is_participating && p.reason)
          .map((p) => ({
            memberId: p.memberId,
            employeeName: p.employeeName,
            departmentName : p.departmentName,
            reason: p.reason,
          }));
        setAbsentReasons(reasons);
      } catch (err) {
        console.error("集計データの取得エラー:", err);
      }
    };

    fetchData();
  }, [eventId]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="summary-container">
      <h2 className="form-title">欠席者リスト</h2>

      {eventInfo && (
        <div className="summary-header">
          <p>
            <strong>イベント名:</strong> {eventInfo.eventName}
          </p>
          <p>
            <strong>開催日:</strong>{" "}
            {new Date(eventInfo.eventDate).toLocaleDateString("ja-JP")}
          </p>
        </div>
      )}


      {/* --- 参加しないの理由--- */}
      {/*<h3 className="reason-title">不参加理由一覧</h3>*/}
      <table className="reason-table">
        <thead>
          <tr>
            <th style={{ width: "10%" }}>社員ID</th>
            <th style={{ width: "20%" }}>氏名</th>
            <th style={{ width: "20%" }}>部署名</th>
            <th style={{ width: "50%" }}>不参加理由</th>
          </tr>
        </thead>
        <tbody>
          {absentReasons.length > 0 ? (
            absentReasons.map((r, idx) => (
              <tr key={idx}>
                <td>{r.memberId}</td>
                <td>{r.employeeName}</td>
                <td>{r.departmentName}</td>
                <td>{r.reason}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", color: "gray" }}>
                不参加理由は登録されていません。
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* --- ボタン --- */}
      <div className="button-group">
        <button type="button" className="btn-print adm-btn" onClick={handlePrint}>印刷</button>
        <button type="button" className="btn-back adm-btn" onClick={() => navigate("/event/list")}>戻る</button>
      </div>
    </div>
  );
};

export default EventAbsentees;
